import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { DomainStakeholder } from '@/entities/domain';

export type DomainUser = {
  id: string;
  name: string;
  fullyQualifiedName: string;
  displayName: string;
  email?: string;
  isBot: boolean;
};

type UsersResponse = {
  data: DomainUser[];
  paging?: {
    total: number;
    after?: string;
  };
};

export const fetchDomainUsers = async (limit: number = 25): Promise<DomainUser[]> => {
  try {
    const { data } = await openMetadataApiClient.get<UsersResponse>('/users', {
      params: {
        limit,
        isBot: false,
      },
    });
    return data.data;
  } catch (error) {
    console.error('Failed to fetch domain users:', error);
    throw error;
  }
};

export const updateDomainExperts = async (
  domainId: string,
  selectedUserIds: string[],
  users: DomainUser[],
  currentExperts: DomainStakeholder[]
): Promise<void> => {
  try {
    const operations: Array<{
      op: string;
      path: string;
      value?: unknown;
    }> = [];

    const newExperts = selectedUserIds.map((userId) => {
      const user = users.find((u) => u.id === userId);
      if (!user) {
        throw new Error(`User with id ${userId} not found`);
      }
      return {
        id: user.id,
        type: 'user',
        name: user.name,
        displayName: user.displayName,
      };
    });

    if (currentExperts && currentExperts.length > 0) {
      operations.push({
        op: 'replace',
        path: '/experts',
        value: newExperts,
      });
    } else {
      operations.push({
        op: 'add',
        path: '/experts',
        value: newExperts,
      });
    }

    if (operations.length > 0) {
      await openMetadataApiClient.patch(`/domains/${domainId}`, operations, {
        headers: {
          'Content-Type': 'application/json-patch+json',
        },
      });
    }
  } catch (error) {
    console.error('Failed to update domain experts:', error);
    throw error;
  }
};
